import { CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";

import { BreadcrumbProvider } from "./contexts/BreadcrumbContext";
import { SnackbarProvider } from "./contexts/SnackbarContext";
// import { SocketProvider } from "./contexts/SocketContext";
import EssilorTheme from "./essilor-theme";
import router from "./router";

function App() {
  return (
    <EssilorTheme>
      <CssBaseline />
      {/* <SocketProvider> */}
      <SnackbarProvider>
        <BreadcrumbProvider>
          <RouterProvider router={router} />
        </BreadcrumbProvider>
      </SnackbarProvider>
      {/* </SocketProvider> */}
    </EssilorTheme>
  );
}

export default App;
